if(!window.dataLayer)window.dataLayer = [];
// eslint-disable-next-line no-unused-vars
const pushData = (data) => {
	window.dataLayer.push(data);
}

export default class Lytics {
	static eventQueue = [];
	static queueTimer = null;
	static queueTimeout = 2000;
	
	// Helper function to check if a SKU is in personalized offers
	static isPersonalizedOffer(sku, personalizedOffers = []) {
		if (!personalizedOffers || !Array.isArray(personalizedOffers)) {
			return false;
		}
		return personalizedOffers.some(offer => offer.sku === sku);
	}

	/**
	 *
	 * @param event
	 * @param opts
	 * @constructor
	 */
	static TriggerEvent(event, opts = {}) {
		console.log('Event Trigger: ' + event, opts);
		pushData({
				'event': event,
				...opts
			});

		window.parent.postMessage({
			direction: 'analytics-relay',
			event,
			...opts
		}, '*');
	}

	static ClearEcommerce() {
		pushData({
			'ecommerce': null
		});
	
	}

	/*
	/**
	 *
	 * @param event
	 * @param category
	 * @param action
	 * @param label
	 * @constructor
	static TriggerEvent(event, category, action, label = '') {
		pushData({
			'event' : event,
			'eventCategory' : category,
			'eventAction' : action,
			'eventLabel' : label
		})
	}*/

	/**
	 * Force a page change event
	 * @param url
	 * @param title
	 * @constructor
	 */
	static TriggerPageChange(url, title) {
		// TODO: DELETE when analytics 2.0 launches
		this.TriggerEvent('virtualPageview',{
			'pageUrl': url || location.href,
			'pageTitle': title || document.title
		});
	}

	static TriggerFlyerLoaded(details = {}) {
		this.TriggerEvent('flyer_loaded', details);
	}

	// TODO: DELETE when analytics 2.0 launches
	static TriggerLoadedFlyers(details = {}) {
		this.TriggerEvent('LoadedFlyers', details);
	}

	/**
	 *
	 * @param {int} page Page Number
	 * @param {string} flyerName
	 * @constructor
	 */
	static TriggerFlyerPageChange(page, flyerName, device_screen) {
		this.TriggerEvent('flyer_page_change',
			{
				device_screen,
				page_number: page,
				// TODO: DELETE fields below when analytics 2.0 launches
				'eventCategory' : 'flyerPage',
				'eventAction' : page,
				'eventLabel' : flyerName
			}
		);//, 'flyerPage', page, flyerName);
	}

	static TriggerDrawerToggle(isOpen) {
		this.TriggerEvent(isOpen ? 'drawer_open' : 'drawer_close');
	}

	static TriggerDrawerChange() {
		this.TriggerEvent('drawer_change');
	}

	/**
	 *
	 * @param {('print'|'email'|'clear')} action
	 * @constructor
	 */
	static TriggerShoppingList(action) {
		this.TriggerEvent('Shopping_list_interactions',
			{
				'eventCategory': 'ShoppingListInteractions',
				'eventAction': action
			});//, 'ShoppingListInteractions', action);
	}

	/**
	 *
	 * @param action {('add'|'remove'|'change_count')}
	 * @param productName
	 * @param extra
	 * @constructor
	 */
	static TriggerShoppingListProduct(action, productName, extra = {}) {
		this.TriggerEvent('Shopping_list_interactions_product',
			{
				'eventCategory': 'ProductInteraction',
				'eventAction': action,
				'eventLabel': productName,
				...extra
			});//, 'ProductInteraction', action, productName);
	}

	static TriggerAddToCart({
		page_number,
		name,
		name_en,
		name_fr,
		product_id,
		price,
		sale_price,
		category,
		category_2,
		image_url,
		quantity,
		personalized_offer = false,
	}) {
		this.ClearEcommerce();
		this.TriggerEvent("add_to_cart", {
			page_number,
			ecommerce: {
				items: [{
					name,
					name_en,
					name_fr,
					product_id,
					price,
					sale_price,
					category,
					category_2,
					image_url,
					quantity,
					personalized_offer
				}]
			}
    });
	}

	/**
	 *
	 * @param action
	 * @param discount
	 * @constructor
	 */
	static TriggerFilter(action, discount) {
		this.TriggerEvent('filter_interaction',{
			filter_name: action,
			filter_selected: discount,
			// TODO: DELETE fields below when analytics 2.0 launches
			'eventCategory' : 'filterInteraction',
			'eventAction' : action,
			'eventLabel' : discount
		});//, 'filterInteraction', action, discount);
	}

	/**
	 *
	 * @constructor
	 */
	static TriggerSearch(request) {
		this.TriggerEvent('search_use',{
			query: request,
			// TODO: DELETE fields below when analytics 2.0 launches
			'eventCategory' : 'searchUse',
			'eventAction' : request
		});//, 'searchUse', request);
	}

	static TriggerHelpClick() {
		this.TriggerEvent('help_clicks');
	}

	static TriggerTutorialViews() {
		this.TriggerEvent('tutorial_views');
	}

	static TriggerTutorialSkip(progress, totalSteps) {
		this.TriggerEvent('tutorial_skip', {
			tutorial_progress: progress,
			tutorial_total_steps: totalSteps
		});
	
	}

	static TriggerTutorialComplete(totalSteps) {
		this.TriggerEvent('tutorial_complete', {
			tutorial_total_steps: totalSteps
		});
	}

	static TriggerShoppingListStart() {
		this.TriggerEvent('shopping_list_start');
	}

	static TriggerCarouselClick(details = {}, isSearch = false) {
		this.TriggerSelectItem({ item_list_name: isSearch ? "search" : "carousel click", ...details });
	}

	static TriggerFullscreenToggle(isFullscreen) {
		this.TriggerEvent('fullscreen_toggle', {
			fullscreen: isFullscreen
		})
	}

	// TODO: DELETE when analytics 2.0 launches
	static TriggerScreenOrientationChange() {
		this.TriggerEvent('ToggleScreenOrientation', {
			category: "ScreenOrientationChange",
		})
	}

	static TriggerOrientationToggle(orientation, device_screen) {
		this.TriggerEvent('orientation_toggle', {
			orientation
		})

		this.TriggerOrientationStatus(orientation, device_screen);
	}

	static TriggerOrientationStatus(orientation, device_screen) {
		this.TriggerEvent('orientation_status', {
			orientation,
			device_screen
		})
	}

	// TODO: DELETE when analytics 2.0 launches
	static TriggerExternalAdClick(details = {}){
		this.TriggerEvent('ExternalAdClick', details);
	}

	static TriggerLinkClick({ url, page_number = null }) {
		this.TriggerEvent('link_click', {
			link_url: url,
			page_number,
			total_click_include: true
		})
	}

	static TriggerAdClick(details = {}){
		this.TriggerEvent('ad_click', details);
		this.TriggerLinkClick({ url: details.ad_url });
	}

	static videoTitleFromUrl(url) {
		if (!url || typeof url !== 'string') {
			return '';
		}
		try {
			const urlObj = new URL(url);
			const pathParts = urlObj.pathname.split('/').filter(Boolean);
			return pathParts.length ? pathParts[pathParts.length - 1] : '';
		} catch (e) {
			console.log('Lytics.videoTitleFromUrl: invalid url', e);
			return '';
		}
	}

	static TriggerVideoClick(url, duration, page_number,video_title, isSearch = false) {
		this.TriggerEvent("video_click", {
			video_url: url,
			video_duration: duration,
			video_title,
			total_click_include: true
		});

		const item_list_name = isSearch ? 'search' : 'video click';
    this.TriggerSelectItem({ item_list_name, page_number, image_url: url })
	}

	static TriggerSelectItem({ item_list_name, page_number, name = "", name_en = "", name_fr = "", product_id = "", price = "", sale_price = "", category = "", category_2 ="", image_url = "", quantity = 1, personalized_offer = false, pdp_type = "" }) {
		this.ClearEcommerce();
		this.TriggerEvent("select_item", {
			page_number,
      ecommerce: {
        item_list_name,
        items: [
          {
            name,
            name_fr,
            name_en,
            product_id,
            price,
            position: 0,
            sale_price,
            category,
			category_2,
            image_url,
            quantity,
            personalized_offer,
            ...(pdp_type && { pdp_type }),
          },
        ],
      },
    });
	}

	static TriggerVideoProgress({url, duration, video_title, progress}) {
		this.TriggerEvent("video_progress", {
			video_url: url,
			video_duration: duration,
			video_title,
			video_watched: progress
		});
	}

	static TriggerVideoCompletion({url, duration, video_title}) {
		this.TriggerEvent("video_completion", {
			video_url: url,
			video_duration: duration,
			video_title,
		});
	}

	// TODO: DELETE when analytics 2.0 launches
	static TriggerVideoLength(details = {}) {
    this.TriggerEvent("VideoLength", details);
  }
	
	static TriggerZoom(isZoomIn) {
		this.TriggerEvent(isZoomIn ? 'zoom_in' : 'zoom_out');
	}
	
	static TriggerTireAdClick(details = {}) {
		this.TriggerEvent('TireAdClick', details);
	}

	static TriggerGotoLandingPage() {
		this.TriggerEvent('NavigateToLandingPage', { category: 'ButtonPressed'})
	}

	static addToEventQueue({ items, item_list_name, page_number = null, personalized_offers = [] }) {
		// Add personalized_offer flag to each item
		const itemsWithPersonalization = items.map(item => ({
			...item,
			personalized_offer: this.isPersonalizedOffer(item.product_id, personalized_offers)
		}));
		
		this.eventQueue.push({ items: itemsWithPersonalization, item_list_name, page_number });
		this.startQueueTimer();
	}

	static startQueueTimer() {
		if (this.queueTimer === null) {
			this.queueTimer = setTimeout(() => this.sendEventQueue(), this.queueTimeout);
		}
	}

	static sendEventQueue() {
    const batchedEvents = {};

    // Group events by item_list_name and page_number
    this.eventQueue.forEach(event => {
        const key = `${event.item_list_name}_${event.page_number}`;
        if (!batchedEvents[key]) {
            batchedEvents[key] = {
                items: [],
                item_list_name: event.item_list_name,
                page_number: event.page_number
            };
        }
        batchedEvents[key].items.push(...event.items);
    });

    // Send batches ensuring no more than 25 items per batch
    for (const key in batchedEvents) {
        const { items, item_list_name, page_number } = batchedEvents[key];
        while (items.length > 0) {
            const batch = items.splice(0, 25);
            this.ClearEcommerce();
            this.TriggerEvent("view_item_list", {
                page_number,
                ecommerce: {
                    item_list_name,
                    items: batch
                }
            });
        }
    }

    this.eventQueue = [];
    clearTimeout(this.queueTimer);
    this.queueTimer = null;
	}


	static TriggerViewItemList({ items, item_list_name }) {
		this.ClearEcommerce();
		this.TriggerEvent("view_item_list", {
			ecommerce: {
				item_list_name,
				items
			}
		});
	}


	static TriggerFlyerImpression({ flyer, client, banner, store_id, platform }) {
		console.log('Flyer Impression:', flyer);
		this.TriggerEvent("flyer_impression", {
      imp_client: client,
      imp_banner: banner,
      imp_store_id: store_id,
			imp_store_name: flyer.storeName,
      imp_version_id: flyer.zonedPublicationName,
      imp_platform: platform,
      imp_deal_id: flyer.title,
      imp_end_date: flyer.endDate,
      imp_start_date: flyer.startDate,
      imp_language: flyer.language,
      imp_job_name: flyer.jobName,
      imp_region: flyer.province,
    });
	}

	static TriggerAdImpression({ name, url, image_url, size, page_number = null }) {
		this.TriggerEvent("ad_impression", {
			ad_name: name,
			ad_url: url,
			ad_image_url: image_url,
			ad_size: size,
			page_number
		});
	}

	static TriggerVideoImpression({ url, video_title, page_number = null}) {
		this.TriggerEvent("video_impression", {
			video_url: url,
			page_number,
			video_title,
		});
	}

	static TriggerAnimatedGraphicImpression({ url, page_number = null }) {
		this.TriggerEvent("animated_graphic_impression", {
      animated_graphic_url: url,
			page_number
    });
	}

	static TriggerCarouselImpression({ id, url, frame, frame_count, page_number = null }) {
		this.TriggerEvent("carousel_impression", {
			carousel_id: id,
			carousel_url: url,
			carousel_frame: frame,
			carousel_frame_max: frame_count,
			page_number,
		});
	}

	static TriggerLinkImpression({ url, page_number = null }) {
		this.TriggerEvent("link_impression", {
			link_url: url,
			page_number,
		});
	}

	static TriggerNextFlyerArrowImpression({ current_flyer_id, current_flyer_position, total_flyers_in_drawer }) {
		this.TriggerEvent("flyer_next_arrow_impression", {
			current_flyer_id,
			current_flyer_position,
			total_flyers_in_drawer
		});
	}

	static TriggerNextFlyerArrowClick({
		orientation,
		current_flyer_id,
		current_flyer_position,
		destination_flyer_id,
		destination_flyer_is_preview,
		total_flyers_in_drawer,
		is_wraparound
		
	}) {
		this.TriggerEvent("flyer_next_arrow_click", {
			orientation,
			current_flyer_id,
			current_flyer_position,
			destination_flyer_id,
			destination_flyer_is_preview,
			total_flyers_in_drawer,
			is_wraparound
			
		});
	}

	static TriggerAddToWishlist({ page_number, name, name_en, name_fr, product_id, price, sale_price, category, category_2, image_url, quantity, personalized_offer = false }) {
		this.ClearEcommerce();
		this.TriggerEvent("add_to_wishlist", {
			page_number,
			ecommerce: {
				items: [{
					name,
					name_en,
					name_fr,
					product_id,
					price,
					sale_price,
					category,
					category_2,
					image_url,
					quantity,
					personalized_offer
				}]
			}
		});
	}

	static TriggerEmailSignupClick() {
		this.TriggerEvent("email_signup_click");
	}

	static TriggerScrollButtonClick({ orientation, page_number, scroll_direction }) {
		this.TriggerEvent("scroll_button_click", {
			orientation,
			page_number,
			scroll_direction
		});
	}

	static TriggerScrollBarClick({ orientation, page_number, scroll_direction }) {
		this.TriggerEvent("scroll_bar_click", {
			orientation,
			page_number,
			scroll_direction
		});
	}

	static TransferToMerchantClick({ page_number, data }) {
		const eventData = {
			page_number,
			total_click_include: true
		};
		if (data) {
			eventData.items = [{
				name: data.productEn || data.productFr,
				name_fr: data.productFr,
				name_en: data.productEn,
				product_id: data.sku,
				price: data.regularPrice,
				position: data.blockData?.index || 0,
				sale_price: data.salePrice,
				category: data.mainCategoryEn || data.mainCategoryFr,
				category_2: data.subCategoryEn || data.subCategoryFr,
				image_url: data.productImage || data.blockData?.images[0]?.image,
				quantity: 1,
				personalized_offer: false
			}];
		}
		this.TriggerEvent("transfer_to_merchant_click", eventData);
	}

	static TriggerInBlockVideoImpression({ url, page_number }) {
		this.TriggerEvent("in_block_video_impression", {
			video_url: url,
			page_number
		});
	}

	static TriggerInBlockVideoClick({ url, page_number }) {
		this.TriggerEvent("in_block_video_click", {
			video_url: url,
			page_number,
			total_click_include: true
		});
	}

	static TriggerAutoCentreClick() {
		this.TriggerEvent("dynamic_promo_click", {
      dynamic_promo_name: "",
      dynamic_promo_id: "",
      dynamic_promo_click_type: "link",
      dynamic_promo_link_name: "Book Now",
      dynamic_promo_url: "",
      dynamic_promo_type: "tire",
      dynamic_promo_sub_type: null
    });
	}

	static TriggerDynamicPromoClick({ id, name, img, type = "unknown", link_name = "Book Now", sub_type = null }) {
		this.TriggerEvent("dynamic_promo_click", {
			dynamic_promo_name: name,
			dynamic_promo_id: id,
			dynamic_promo_click_type: "tile",
			dynamic_promo_link_name: link_name,
			dynamic_promo_url: img,
			dynamic_promo_type: type,
			dynamic_promo_sub_type: sub_type
		});
	}

	static TriggerDynamicPromoImpression({ id, name, img, type = "unknown", sub_type = null }) {
		this.TriggerEvent("dynamic_promo_impression", {
			dynamic_promo_name: name,
			dynamic_promo_id: id,
			dynamic_promo_url: img,
			dynamic_promo_type: type,
			dynamic_promo_sub_type: sub_type
		});
	}

	static TriggerActivateOffer({ name = '', offer = null, position = 0 }) {
		this.ClearEcommerce();
		this.TriggerEvent("activate_offer", {
			ecommerce: {
				items: [{
					name: offer?.description || name,
					name_fr: offer?.description || name,
					name_en: offer?.description || name,
					product_id: offer?.offerCode || '',
					price: offer?.regularPrice || '',
					position: position,
					sale_price: offer?.salePrice || '',
					category: offer?.mainCategory || '',
					category_2: offer?.subCategory || '',
					image_url: offer?.imageUrl || '',
					quantity: 1,
					personalized_offer: true
				}]
			}
		});
		
		this.ClearEcommerce();
		this.TriggerEvent("offer_click", {
			offer_name: name,
			ecommerce: {
				items: [{
					name: offer?.description || name,
					name_fr: offer?.description || name,
					name_en: offer?.description || name,
					product_id: offer?.offerCode || '',
					price: offer?.regularPrice || '',
					position: position,
					sale_price: offer?.salePrice || '',
					category: offer?.mainCategory || '',
					category_2: offer?.subCategory || '',
					image_url: offer?.imageUrl || '',
					quantity: 1,
					personalized_offer: true
				}]
			}
		});
	}

  static TriggerOfferImpression({ 
		name, 
		name_fr, 
		name_en, 
		product_id, 
		price, 
		position, 
		sale_price, 
		category, 
		category_2, 
		image_url, 
		quantity, 
		personalized_offer 
	}) {
		this.ClearEcommerce();
		this.TriggerEvent("offer_impression", {
			ecommerce: {
				items: [{
					name,
					name_fr,
					name_en,
					product_id,
					price,
					position,
					sale_price,
					category,
					category_2,
					image_url,
					quantity,
					personalized_offer
				}]
			}
		});
	}

  static TriggerStoreSelectorOpen({ store_id, store_name }) {
		this.TriggerEvent('store_selector_open', {
			store_id: store_id,
			store_name: store_name
		});
	}

	static TriggerStoreSelectorSelect({ store_id, store_name }) {
		this.TriggerEvent('store_selector_select', {
			store_id: store_id,
			store_name: store_name
		});
	}
}
